<p-blockUI [target]="pnlBlock" [blocked]="show">
  <p-progress-spinner strokeWidth="8" fill="transparent" animationDuration=".5s"
    [style]="{ width: '50px', height: '50px' }" />
</p-blockUI>
<p-panel #pnlBlock>
  <ng-content></ng-content>
</p-panel>